import React from 'react'

const SingleEmployesPayrolls = ({
    auto
  ,
    date
 ,
    deserved_amount
,
    discount_amount
 ,
    extra_amount
  ,
    hr_contract_id
 ,
    id
,
    loan_amount
  ,
    sb_branch_id
   ,
    sb_company_id
  ,
    sb_employe_id
,
    status
,
    undeserved_amount
   



}) => {
  return (
    <tr>
        <td>{id}</td>
        <td>{deserved_amount}</td>
         <td>{undeserved_amount}</td>
        <td>{extra_amount}</td>
        <td>{discount_amount}</td>
        <td>{loan_amount}</td>
        <td>{status}</td> 
    </tr>
  )
}

export default SingleEmployesPayrolls